const popupPrimaryContainer = document.querySelector('.popup-primary') as HTMLDivElement | null;
const popupContainer = document.querySelector('.popup-container') as HTMLDialogElement | null;
const primaryImageButton = document.querySelector('.popup-primary .image-button') as HTMLButtonElement | null;
const imageButtons = document.querySelectorAll('.img-grid .image-button') as NodeListOf<HTMLButtonElement>;
const galleryImageButtons = document.querySelectorAll('.img-select-grid .image-button') as NodeListOf<HTMLButtonElement>;
const popupGallery = document.querySelector('.popup-gallery') as HTMLDivElement | null;
const popupFigure = document.querySelector('.popup-gallery figure') as HTMLElement | null;
const popupCloseButton = document.querySelector('.popup-gallery .popup-close') as HTMLButtonElement | null;
const previousButton = document.querySelector('.popup-gallery .image-prev') as HTMLButtonElement | null;
const nextButton = document.querySelector('.popup-gallery .image-next') as HTMLButtonElement | null;

if (primaryImageButton) {
    let imageHeight = 0;

    imageButtons.forEach(button => {
        button.addEventListener('mouseover', () => {
            const newImage = button.firstElementChild as HTMLImageElement;
            primaryImageButton.style.minWidth = window.getComputedStyle(button).width;
            primaryImageButton.style.minHeight = window.getComputedStyle(button).height;
            primaryImageButton.firstElementChild?.replaceWith(newImage.cloneNode());
            primaryImageButton.dataset.index = button.dataset.index;
            (primaryImageButton.firstElementChild as HTMLElement).style.maxHeight = `${imageHeight}px`;
        });

        button.addEventListener('click', () => {
            if (popupFigure) {
                popupFigure.dataset.index = button.dataset.index;
                
                if (popupFigure.firstElementChild) {
                    popupFigure.firstElementChild.replaceWith(button.firstElementChild?.cloneNode() as HTMLElement);
                } else {
                    popupFigure.appendChild(button.firstElementChild?.cloneNode() as HTMLElement);
                }

                (popupFigure.firstElementChild as HTMLElement).style.removeProperty('max-height');

                document.documentElement.classList.add('behind');
                
                galleryImageButtons.forEach(galleryButton => {
                    if (galleryButton.dataset.index !== button.dataset.index) {
                        galleryButton.classList.remove('active');
                    } else {
                        galleryButton.classList.add('active');
                    }
                });

                popupContainer?.showModal();
                popupCloseButton?.focus();
            }

        });

        imageHeight = Math.min((button.firstElementChild as HTMLImageElement).naturalHeight, 400);
    });

    if (popupPrimaryContainer) {
        popupPrimaryContainer.style.height = `${imageHeight}px`;
        primaryImageButton.style.maxHeight = `${imageHeight}px`;
    }

    primaryImageButton.addEventListener('click', () => {
        if (popupFigure) {
            popupFigure.dataset.index = primaryImageButton.dataset.index;

            if (popupFigure.firstElementChild) {
                popupFigure.firstElementChild.replaceWith(primaryImageButton.firstElementChild?.cloneNode() as HTMLElement);
            } else {
                popupFigure.appendChild(primaryImageButton.firstElementChild?.cloneNode() as HTMLElement);
            }

            (popupFigure.firstElementChild as HTMLElement).style.removeProperty('max-height');

            document.documentElement.classList.add('behind');

            galleryImageButtons.forEach(galleryButton => {
                if (galleryButton.dataset.index !== primaryImageButton.dataset.index) {
                    galleryButton.classList.remove('active');
                } else {
                    galleryButton.classList.add('active');
                }
            });
            
            popupContainer?.showModal();
            popupCloseButton?.focus();
        }
    });

    galleryImageButtons.forEach(button => button.addEventListener('click', () => {
        if (popupFigure) {
            popupFigure.dataset.index = button.dataset.index;
            
            if (popupFigure.firstElementChild) {
                popupFigure.firstElementChild.replaceWith(button.firstElementChild?.cloneNode() as HTMLElement);
            } else {
                popupFigure.appendChild(button.firstElementChild?.cloneNode() as HTMLElement);
            }

            galleryImageButtons.forEach(galleryButton => {
                if (galleryButton !== button) galleryButton.classList.remove('active');
            });

            button.classList.add('active');
        }
    }));

    popupCloseButton?.addEventListener('click', () => {
        popupContainer?.close();
        document.documentElement.classList.remove('behind');
    });

    popupContainer?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            document.documentElement.classList.remove('behind');
        }
    });

    popupContainer?.addEventListener('click', event => {
        if (!popupGallery?.contains(event.target as Node)) {
            popupContainer?.close();
            document.documentElement.classList.remove('behind');
        }
    });

    nextButton?.addEventListener('click', () => {
        if (popupFigure) {
            let index = parseInt(popupFigure.dataset.index ?? '0');
            if (galleryImageButtons[index + 1]) {
                popupFigure.firstElementChild?.replaceWith(galleryImageButtons[index + 1].firstElementChild?.cloneNode() as HTMLElement);
                popupFigure.dataset.index = `${index + 1}`;                

                galleryImageButtons.forEach(galleryButton => {
                    if (galleryButton.dataset.index !== `${index + 1}`) {
                        galleryButton.classList.remove('active');
                    } else {
                        galleryButton.classList.add('active');
                    }
                });
            }
        }
    });

    previousButton?.addEventListener('click', () => {
        if (popupFigure) {
            let index = parseInt(popupFigure.dataset.index ?? '0');
            if (galleryImageButtons[index - 1]) {
                popupFigure.firstElementChild?.replaceWith(galleryImageButtons[index - 1].firstElementChild?.cloneNode() as HTMLElement);
                popupFigure.dataset.index = `${index - 1}`;

                galleryImageButtons.forEach(galleryButton => {
                    if (galleryButton.dataset.index !== `${index - 1}`) {
                        galleryButton.classList.remove('active');
                    } else {
                        galleryButton.classList.add('active');
                    }
                });
            }
        }
    });
}
